var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorArrival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.017,24.565l-.88-1.04c-.57-.674-1.297-1.196-2.118-1.519l-8.519-3.362-6.895-13.642-3.957-1.562,4.152,12.56-8.602-3.395-1.501-3.051-1.982-.782.095,5.527c.022,1.28.813,2.421,2.003,2.891l22.669,8.947c1.349.532,2.768.865,4.213.987h0c1.384.117,2.218-1.498,1.321-2.558Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.255,
    y: 35.019,
    width: 25.03,
    height: 3.541
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorArrival);
export default __webpack_public_path__ + "static/media/indoor-arrival.49caf41ad919f61483e1d7d8ca1abde4.svg";
export { ForwardRef as ReactComponent };